import Bugsnag from '@bugsnag/js';

export const cleanValues = (value) =>
  (Array.isArray(value) ? value.flat(Infinity) : [value])
.filter(x => x != null && x !== "" && x !== "__dummy__" && (typeof x !== "string" || x.trim() !== ""));

// (company, college, location, etc.) are effectively unbounded which might flood Mixpanel
const LOW_CARDINALITY_TAB_KEYS = new Set([ "sort", "type", "sec_category", "mentioned_for" ]);
// Prospects and Newsfeed's filter builder
export const buildFilterTabsAnalytics = (filtersState = {}, allFilterTabs = []) => {
  const filters = [];
  try {
    const selected = filtersState.filtersSelected || {};
    const labelByKey = {};
    (allFilterTabs || []).forEach((tab) => {
      if (tab?.tab_key) labelByKey[tab.tab_key] = tab.label || tab.tab_key;
    });
    Object.keys(selected).forEach((key) => {
      const values = cleanValues(selected[key]);
      if (!values.length) return;
      const entry = { field: labelByKey[key] || key, count: values.length };
      if (LOW_CARDINALITY_TAB_KEYS.has(key)) entry.values = values;
      filters.push(entry);
    });
  } catch (e) {
    Bugsnag.notify(e);
  }
  return {
    filter_count: filters.length,
    filters,
  };
};
